<ng-container *ngIf="tabs.length > 0 && !hideSelection">
  <div class="soft-tab-group" [ngClass]="customClass">
    <div
      *ngFor="let tab of tabs; let i = index"
      class="soft-tab relative"
      [ngClass]="tab.class?.()"
      [class.selected-tab]="activatedIndex === i"
      (click)="activateIndex(i)"
    >
      @let icon = tab.icon?.() ?? null;

      @if (icon) {
        <soft-icon [name]="icon"></soft-icon>
      }

      <ng-template [ngIf]="tab.templateTitle">
        <ng-template [cdkPortalOutlet]="tab.templateTitle"></ng-template>
      </ng-template>

      @if (!tab.templateTitle && isDefinedNotEmpty(tab.title)) {
        <span class="soft-tab-title">{{ tab.title }}</span>
      }

      @if (tab.badge?.() !== 0 && tab.badge?.() !== undefined) {
        <span
          class="absolute rounded-full bg-danger min-w-[16px] z-10 min-h-[16px] text-center flex items-center pl-[0.05rem] pb-[0.001rem] justify-center text-white text-[9px] font-semibold tracking-tighter"
          [ngClass]="tab?.badgeClass?.() ? tab?.badgeClass() : 'top-2 right-2'"
          >{{ tab.badge?.() | number: '1.0-0' }}
        </span>
      }

      <div *ngIf="activatedIndex === i" class="soft-tab-indicator"></div>
    </div>
  </div>
</ng-container>

@if (activatedTab?.content && displayMode() !== 'barOnly') {
  <div class="soft-tab-content" [cdkPortalOutlet]="activatedTab?.content"></div>
}
